import * as tslib_1 from "tslib";
import { Apollo } from 'apollo-angular';
import { ARCHIVE_LOCATION_SECTOR_MUTATION, UNARCHIVE_LOCATION_SECTOR_MUTATION } from './location-sectors.query';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
var ArchiveLocationSectorApi = /** @class */ (function () {
    function ArchiveLocationSectorApi(apollo) {
        this.apollo = apollo;
    }
    ArchiveLocationSectorApi.prototype.archive = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apollo.mutate({
                            mutation: ARCHIVE_LOCATION_SECTOR_MUTATION,
                            variables: { input: params },
                        }).toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ArchiveLocationSectorApi.prototype.unarchive = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apollo.mutate({
                            mutation: UNARCHIVE_LOCATION_SECTOR_MUTATION,
                            variables: { input: params },
                        }).toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ArchiveLocationSectorApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ArchiveLocationSectorApi_Factory() { return new ArchiveLocationSectorApi(i0.ɵɵinject(i1.Apollo)); }, token: ArchiveLocationSectorApi, providedIn: "root" });
    return ArchiveLocationSectorApi;
}());
export { ArchiveLocationSectorApi };
